import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-quantity-selector',
  templateUrl: './quantity-selector.component.html',
  styleUrls: ['./quantity-selector.component.scss'],
})
export class QuantitySelectorComponent {
  /**
   * Qunatity to show
   */
  @Input() quantity: number;

  /**
   * Disables quantity selector
   */
  @Input() disabled: boolean;

  /**
   * increase event emitter
   */
  @Output() increase: EventEmitter<number> = new EventEmitter<number>();

  /**
   * decrease event emitter
   */
  @Output() decrease: EventEmitter<number> = new EventEmitter<number>();

  /**
   * Emits the decrease event
   *
   * @param event click event
   */
  public onDecreaseQuantity(event: Event): void {
    if (this.disabled || this.quantity <= 1) {
      return;
    }

    // update quantity
    this.quantity = this.quantity > 1 ? this.quantity - 1 : 1;

    // events
    event.stopPropagation();
    this.decrease.emit(this.quantity);
  }

  /**
   * Emits the increase event with the current number
   *
   * @param event click event
   */
  public onIncreaseQuantity(event: Event): void {
    if (this.disabled) {
      return;
    }

    // update quantity
    this.quantity++;

    // events
    event.stopPropagation();
    this.increase.emit(this.quantity);
  }
}
